module.exports = __webpack_public_path__ + "static/media/Logo_of_Rule_Cambodia.1c212748.png";